module.exports = __webpack_public_path__ + "static/media/elivate.fa3a343f.svg";